import {
  currentTimeKey,
  propsKey,
  userProductItemsKey,
  userRoleKey,
} from '@wirechunk/lib/expressions/evaluator.ts';
import { ConditionalLogicDataContext, CurrentUserContext } from '@wirechunk/ui';
import { use, useMemo, type FunctionComponent, type PropsWithChildren } from 'react';

// This is for the currentTime field of the object that is passed to buildContextData.
const getCurrentTime = () => Date.now();

const currentTime = getCurrentTime();

// Provides the root ConditionalLogicDataContext value. Requires a CurrentUserContext to be provided but nothing else.
export const RootConditionalLogicDataContextProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const { user } = use(CurrentUserContext);
  // const [currentTime, setCurrentTime] = useState(getCurrentTime);
  // useEffect(() => {
  //   const id = setInterval(() => {
  //     setCurrentTime(getCurrentTime());
  //   }, 30_000);
  //   return () => {
  //     clearInterval(id);
  //   };
  // }, []);
  const value = useMemo<ConditionalLogicDataContext>(
    () => ({
      [currentTimeKey]: currentTime,
      [propsKey]: undefined,
      [userProductItemsKey]: user?.productItems,
      [userRoleKey]: user?.role,
    }),
    // [user, currentTime],
    [user],
  );
  return <ConditionalLogicDataContext value={value}>{children}</ConditionalLogicDataContext>;
};
